import ManifestFallbackIcon from './ManifestFallbackIcon'

export default ManifestFallbackIcon
